<template>
  <div class="banner pt3-ns pt2 ph3 ph0-l mr2-l">
    <div v-show="loading" class="flex justify-center w-100 mv3">
      <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
    </div>
    <carousel :per-page="1" :loop="true" ref="carousel" :autoplay="true" :autoplayTimeout="10000" class="h-100 w-100">
      <slide v-for="banner in banners" :key="banner.id" class="h-100 w-100">
        <a :href="banner.link" class="banner w-100" target="_blank">
          <div class="image-container relative db w-100 banner cover center"
             :style=" { 'background-image': 'url(' + picture(banner) + ')' }"/>
        </a>
      </slide>
    </carousel>
  </div>
</template>

<script>

import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import { mapActions } from 'vuex'
import consts from '@/consts'
export default {
  name: 'banner',
  data () {
    return {
      banners: [],
      color: '#808080',
      size: '30px'
    }
  },
  components: {
    ClipLoader
  },
  methods: {
    ...mapActions('home', [
      'getBanners'
    ]),
    picture (banner) {
      return consts.MEDIA_BASE_URL + banner.image
    }
  },
  created () {
    this.getBanners().then((res) => {
      this.banners = res
    }).catch((e) => {
      this.$toasted.show(e, {type: 'error'})
    })
  },
  computed: {
    loading () {
      return this.$loading.isLoading('home getBanners')
    }
  }
}
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';
  .banner {
    height: 195px;
  }

  .VueCarousel /deep/ .VueCarousel-wrapper {
    height: 100%;
  }

  .VueCarousel /deep/ .VueCarousel-pagination {
    display: none !important;
  }

  .image-container {
    background-position: center center;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/Banner.vue